<template>
    <div v-if="filters">
        <a href="#" @click.prevent="expanded = ! expanded">
            Searching
            <template v-if="filters.only_approved_entries">
                approved
            </template>
            entries in
            <strong>{{ filters.selected_events.length || upcomingEvents.length }}</strong> events
            <i :class="`fa fa-lg fa-caret-${expanded ? 'up' : 'down'}`"></i>
        </a>
        <div class="row text-left options-container" v-if="expanded">
            <div class="col-sm-6">
                <strong>Events</strong>
                <div class="checkbox" v-for="event in upcomingEvents">
                    <label>
                        <input @change="optionsChanged" type="checkbox" :value="event.id"
                               v-model="filters.selected_events">{{ event.name }}
                    </label>
                </div>
            </div>

            <div class="col-sm-6">
                <strong>Filters</strong>
                <div class="checkbox"><label>
                    <input @change="optionsChanged" type="checkbox" :value="1" v-model="filters.only_approved_entries">
                    Only include people with approved entries</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        data() {
            return {
                filters: null,
                expanded: false,
            };
        },

        methods: {
            ...mapMutations(['setFilters']),

            optionsChanged: _.debounce(() => window.Event.fire('search-updated'), 800),
        },

        computed: {
            ...mapState(['upcomingEvents']),
        },

        mounted() {
            this.filters = this.$store.state.filters;
        },

        watch: {
            filters: {
                handler: function (newFilters) {
                    this.setFilters(newFilters);
                },
                deep: true
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../../sass/variables";

    .options-container {
        margin-top: 10px;
        padding: 10px;
        padding-top: 20px;
        background-color: darken($body-bg, 5);
    }
</style>
